import { designToken } from '../component-tokens';
export const tileTokens = {
    name: 'tile',
    tag: 'chameleon-tile',
    reactImports: 'Tile',
    attributes: {
        'background-color': designToken('tile-background'),
        'border-color': designToken('tile-border'),
    },
    states: [
        {
            name: 'hover',
            attributes: {
                'background-color': designToken('tile-background-hover'),
                'border-color': designToken('tile-background-hover'),
            },
        },
        {
            name: 'active',
            attributes: {
                'background-color': designToken('tile-background-active'),
                'border-color': designToken('tile-background-active'),
            },
        },
    ],
    variants: [
        {
            name: 'secondary',
            attributes: {
                'background-color': designToken('tile-background-secondary'),
                'border-color': designToken('tile-border-secondary'),
            },
        },
        {
            name: 'secondary-hover',
            attributes: {
                'background-color': designToken('tile-background-secondary-hover'),
            },
        },
        {
            name: 'secondary-active',
            attributes: {
                'background-color': designToken('tile-background-secondary-active'),
            },
        },
        {
            name: 'selected',
            attributes: {
                'background-color': designToken('tile-background-selected'),
                'border-color': designToken('tile-background-selected'),
            },
        },
        {
            name: 'disabled',
            attributes: {
                'background-color': designToken('tile-background-disabled'),
                'border-color': designToken('tile-border-disabled'),
            },
        },
    ],
};
